export default "__VITE_ASSET__Bxid2tLe__"